<!--

type
prop
label
width
fixWidth 固定宽
slot
align
fixed
sortable
children
prophtml

-->
<template>
  <div class="data-board-table">
    <el-table :data="dataList" :default-sort="sortObj" :header-cell-style=" {background: '#fafafa',color:'#333333'}" :max-height="heightStr"
              v-loading="loading" >
      <template v-for="({ type, prop, label, width, slot, align, fixed, sortable, fixWidth, children, prophtml }, index) in config">
        <el-table-column
            :key="index"
            :label="label"
            :type="type"
            :width="width"
            :align="align"
            v-if="type"
        ></el-table-column>
        <el-table-column
            :key="index"
            :prop="prop"
            :label="label"
            :min-width="width"
            :width="fixWidth"
            :fixed="fixed"
            :align="align"
            :sortable="sortable"
            v-else-if="slot"
        >
          <template slot-scope="scope">
            <el-image v-if="slot === 'image'" :src=imageArr[scope.$index] :preview-src-list=imageArr></el-image>
            <el-input v-if="slot === 'index'" v-model="scope.$index" placeholder="请输入内容"></el-input>
            <el-input v-if="slot === 'input'" v-model="scope.row.goodsNo" placeholder="请输入内容"></el-input>
            <p v-if="slot === 'html'" v-html="scope.row.content"></p>

            <div class="operateBtn" v-if="typeStr=='operator'">
              <label type="primary" @click="examine(scope.row)">查看</label>
              <label type="primary" @click="suspension(scope.row)">暂停</label>
              <label type="primary" @click="onShowDetail(scope.row)">下载</label>
              <el-dropdown>
                <span class="el-dropdown-link">
                  <i style="font-size:12px" class="el-icon-more"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item ><label type="primary" @click="changeHistory(scope.row)">变更历史</label></el-dropdown-item>
                  <el-dropdown-item > <label type="primary" @click="deleteFlock(scope.row)">删除</label></el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <!--            <p v-if="slot === 'button'">测试一下</p>-->
          </template>
        </el-table-column>
        <el-table-column
            :key="prop"
            :prop="prop"
            :label="label"
            :min-width="width"
            :width="fixWidth"
            :align="align"
            :sortable="sortable"
            v-else-if="children"
        >
          <el-table-column
              v-for="(itemchildren, indexchildren) in children"
              :key="indexchildren"
              :prop="itemchildren.prop"
              :min-width="itemchildren.width"
              :width="itemchildren.fixWidth"
              :label="itemchildren.label"
              show-overflow-tooltip
              :align="itemchildren.align"
              :sortable="itemchildren.sortable"
          ></el-table-column>
        </el-table-column>
        <el-table-column
            :key="prop"
            :prop="prop"
            :label="label"
            :min-width="width"
            :width="fixWidth"
            :align="align"
            :sortable="sortable"
            v-else
        ></el-table-column>
      </template>
    </el-table>
  </div>
</template>

<script>
/**
 *       staffTableConfigs: { // 员工排行榜
 *         sortObj: { prop: 'marketPrice', order: 'descending' }, // 排序
 *         list: [
 *           { type: 'index', label: '排名', width: 60 },
 *           { prop: 'brandName', label: '姓名' },
 *           { prop: 'marketPrice', label: '销售额' },
 *           { prop: 'marketPrice', label: '售后订单数', sortable: true },
 *           { prop: 'stock', label: '订单总数' }
 *         ]
 *       },
 */
export default {
  name: 'CommonTable',
  props: {
    typeStr: {
      type: String,
      default: () => ''
    },
    sortObj: { // 排序
      type: Object,
      default: () => {
      }
    },
    config: {
      type: Array,
      default: () => []
    },
    dataList: { // 数据列表
      type: Array,
      default: () => []
    },
    heightStr: { // 数据列表 高度
      type: String,
      default: () => '888'
    },
    loading: {
      type: Boolean,
      default: () => false
    }
  },
  data () {
    return {
      // levelList: null,
    }
  },
  watch: {
    $route () {
      // this.testFun();
    }
  },
  mounted () {
    this.$nextTick(_ => {})
  },
  created () {
    // this.testFun()
  },
  methods: {
    // 变更历史
    changeHistory (row) {
      this.$router.push({ name: 'labelChangeRecord', query: { pageTitle: 1, groupId: row.id }})
    },
    // 查看
    examine (row) {
      this.$router.push({ name: 'LabelGroupDetail', query: { tabsActiveName: 'pie', groupId: row.id }})
    },
    // 暂停/启动
    suspension (row, type) {
      this.$emit('suspension', row, type)
    },
    // 删除分群
    deleteFlock (row) {
      this.$emit('deleteFlock', row)
    },
    // 近一年员工业绩 查看 按钮
    onShowDetail (row) {
      this.$emit('tableShowDetail', row)
      // console.log('onShowDetail - 查看', row)
    }
    // 表格表头合并
  }
}
</script>
<style lang="scss">
.data-board-table {
  width: 100%;
  color: #333333;

  .el-table {
    border: 1px solid #E8EAEC;
    //固定栏
    thead {
      color: #333333;
    }

    .el-table__header-wrapper {
      .has-gutter {
        color: #333333;

        .el-table__cell {
          .cell {
            font-weight: bold;
            font-size: 16px;
          }
        }
      }
    }
    .el-table__body-wrapper, .el-table__body {
      .el-table__row {
        .el-table__cell {
          .cell {
            color: #333333;
            font-size: 14px;
          }
        }
      }
    }
  }
}
.operateBtn{
  display: flex;
  align-items: center;
  justify-content: space-around;
}
//固定栏
//.el-table--enable-row-transition .el-table__body .el-table__row {
//  &:nth-child(even){
//    td.el-table__cell{
//      background-color: #F4F7FC;
//    }
//  }
//}
.el-dropdown{
  width: 18px !important;
  height: 18px !important;
  display: flex !important;
  justify-content: center;
  align-items: center !important;
  background: #e3edff !important;
  color:#7b96ee ;
  border-radius: 50%;
  font-size: 12px;
}

</style>
